<template>
  <UContainer>
    <h2 class="text-4xl text-center text-primary font-bold">
      {{ blok.title }}
    </h2>
    <p
      v-for="(line, lineIdx) of (blok.description ?? '').split('\n')"
      :key="lineIdx"
      class="text-center text-xl my-4"
    >
      {{ line }}
    </p>

    <div class="flex flex-wrap w-full gap-4 justify-around">
      <div v-for="(photo, photoIdx) of blok.photos" :key="photoIdx">
        <NuxtImg
          :src="photo.filename"
          :alt="`${blok.title}: ${(photoIdx as number) + 1}`"
          class="w-full aspect-square max-w-[16rem] rounded-xl"
          fit="in"
          height="336"
          width="336"
          :modifiers="{ filters: { fill: 'transparent' } }"
          :provider="
            photo.filename.includes('a.storyblok.com') ? 'storyblok' : undefined
          "
          @click="() => openModal(photoIdx as number)"
        />
      </div>
    </div>
    <UModal v-model:open="modalOpen" class="bg-transparent">
      <template #content>
        <UCarousel
          v-slot="{ item }"
          ref="carousel"
          arrows
          :items="blok.photos"
          class="w-full mx-auto"
          :ui="{
            next: 'end-2 sm:end-2',
            prev: 'start-2 sm:start-2',
          }"
        >
          <NuxtImg
            :src="item.filename"
            width="720"
            class="max-h-[70dvh] w-full h-full"
            provider="storyblok"
          />
        </UCarousel>
      </template>
    </UModal>
  </UContainer>
</template>
<script setup lang="ts">
defineProps<{
  blok: any;
}>();

const modalOpen = ref(false);
const carousel = useTemplateRef("carousel");

function openModal(i: number) {
  modalOpen.value = true;
  setTimeout(() => {
    console.log("scrolling to", i, typeof i);
    carousel.value?.emblaApi?.scrollTo(i);
  }, 1);
}
</script>
